import { getAffiliations, patchAffiliations } from '@fno/service/api/affiliations.js'
import { getSchool, patchSchool } from '@fno/service/api/schools.js'
import { preFormMutator, preSaveMutator, getKeypath, preChangeMutator, nextHandler, previousHandler } from '@fno/route/hello/task/helpers.js'
import template from './Affiliations.svelte'
import genericChange from '@fno/lib/form/generic-change.js'
import genericReset from '@fno/lib/form/generic-reset.js'
import genericSave from '@fno/lib/form/generic-save.js'
import schoolSchema from 'fanx-schema/resource/school'
import affiliationsSchema from 'fanx-schema/resource/affiliations'
import transformApiResponseToFormObject from '@fno/lib/transform-api-response-to-form-object.js'
import setContextOriginal from '@fno/lib/form/set-context-original.js'

const page = {
    school: {
        type: Object,
        schema: schoolSchema,
        patch: school => patchSchool({ school })
    },
    affiliations: {
        type: Object,
        schema: affiliationsSchema,
        patch: affiliations => patchAffiliations({ affiliations })
    }
}

export default (parent, stateRouter) => {
    const name = `${parent}.affiliations`

    stateRouter.addState({
        name,
        route: '/affiliations',
        template,
        data: {
            title: 'Affiliations | T.A.B.'
        },
        resolve: async (ignore, { schoolId }) => {
            const [ school, affiliations ] = await Promise.all([
                getSchool({ schoolId }),
                getAffiliations({ schoolId })
            ])

            return setContextOriginal({
                context: {
                    form: {
                        school: transformApiResponseToFormObject({ schema: schoolSchema, data: school }),
                        affiliations: transformApiResponseToFormObject({ schema: affiliationsSchema, data: affiliations })
                    },
                    view: {
                        affiliationSchema: affiliationsSchema.properties.affiliations.fragmentType.properties
                    }
                }
            }, preFormMutator)
        },
        activate: ({ domApi: component, parameters: { schoolId } }) => {
            const save = genericSave({ component, page, preSaveMutator, preFormMutator })
            component.$on('nextStepClicked', nextHandler({
                stateRouter,
                component,
                save,
                schoolId,
                stepId: 'AFFILIATIONS',
                nextId: 'developerAccount'
            }))
            component.$on('previousStepClicked', previousHandler(stateRouter, 'appNaming', schoolId))
            component.$on('change', genericChange({ component, page, getKeypath, preChangeMutator }))
            component.$on('reset', genericReset({ component }))
            component.$on('save', save)
        }
    })
}
